import { PayloadAction, createSlice, isDraft } from '@reduxjs/toolkit';
import { MenuItem } from 'primereact/menuitem';
import { carrierList } from '../../DocuMate/DocuMateRefi/DocuMateRefiService';

export interface CarrierListState{
    carrierList:MenuItem[]
}
const initialState : CarrierListState = {
    carrierList:[]
}

 function  updateCarrierList(state, action: PayloadAction<{data:MenuItem[],Id?:string,propertyToUpdate?:string, type?:string}> ){
     console.log(action.payload.type)
     switch (action.payload.type) {
         case 'StoreCompanyList':
             state.carrierList = [...action.payload.data]
             break;
         case 'UpdateInsuredList':
             {
                console.log('called',action.payload.Id)
                const itemIndex = state.carrierList.findIndex((item) => item.id === action.payload.Id);
                const item = state.carrierList.find((item) => item.id === action.payload.Id);
                state.carrierList[itemIndex]["items"]=[...action.payload.data]
                 }
                break;
            default:
        return state;
        }
 }

     const carrierSlice = createSlice({
         name: "carrierMenu",
         initialState,
         reducers: {
             updateCarrier: (state, action) => {
                if(state.carrierList.length<=0){
                    state.carrierList = [...action.payload.data]
                }
                else{
                   state.carrierList.map((ele)=>{
                        if(ele.id === action.payload.id){
                            let items=action.payload.find((e)=>e.id===ele.id)?.items;
                           {ele.items,items} 
                        }
                    })
                }
             }
         }

     });

export const { updateCarrier } = carrierSlice.actions;
export default carrierSlice.reducer;